import { useEffect } from "react";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import { HomeMainCompProps } from "../../components/home-main-comp/home-main.comp";
import ImgListContainer from "../../components/img-list-container/img-list-container.comp";
import SmallImgListContainer from "../../components/img-list-container/small-img-list-container.comp";
import "./small-home.page.scss";

const SmallHomePage = ({ homeMainCompData }: HomeMainCompProps) => {
  const d = homeMainCompData;
  const subtitles = d.subtitle.split("<split/>");
  const text = d.text?.split("<split/>");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    location.hash &&
      document
        .querySelector(location.hash)
        ?.scrollIntoView({ behavior: "smooth" });

    window.addEventListener("touchstart", () => {
      const imgWrapperList = Array.from(
        document.querySelectorAll(".img-list-item .img-wrapper")
      ) as HTMLElement[];
      imgWrapperList.forEach((el) => {
        el.style.filter = "saturate(1)";
      });
    });
    window.addEventListener("touchend", () => {
      const imgWrapperList = Array.from(
        document.querySelectorAll(".img-list-item .img-wrapper")
      ) as HTMLElement[];
      imgWrapperList.forEach((el) => {
        el.style.filter = "saturate(0)";
      });
    });
  }, [location.hash]);

  return (
    <article
      className={`small-home-container ${d.label}-section`}
      id={`${d.label}-section`}
    >
      <div
        className="cover-image-container"
        style={{ backgroundImage: `url(${d.img})` }}
      />

      <div className="text-container">
        <div className="title-container">
          <p className="subtitle">
            {subtitles[0]}
            {subtitles.length > 1 && (
              <span className="first-name">{subtitles[1]}</span>
            )}
          </p>
          <h3 className="title">{d.title}</h3>
        </div>

        <div className="text">
          {text && text[0]}
          {text && text.length > 1 && location.pathname === "/about-me" && (
            <>
              <b>{text[1]}</b>
              {text[2]}
            </>
          )}
        </div>

        <aside className="children">{d.children}</aside>

        <div className="action-container">
          {d.button.map((b) => (
            <button
              onClick={() => onClickCoverButton(b.value, navigate)}
              key={b.label + b.value}
            >
              {b.label}
            </button>
          ))}
        </div>
      </div>

      <div className="down-mask"></div>

      <div className="image-container-list">
        <SmallImgListContainer
          homeMainCompData={homeMainCompData}
        ></SmallImgListContainer>
      </div>
    </article>
  );
};

export default SmallHomePage;

/* HELPS */

const onClickCoverButton = (
  target: "more-ig" | "more-dev" | "as-ig" | "as-dev",
  navigate: NavigateFunction
) => {
  switch (target) {
    case "as-dev": {
      document
        .querySelector("#developer-section")
        ?.scrollIntoView({ behavior: "smooth" });
      break;
    }
    case "as-ig": {
      document
        .querySelector("#graphic-designer-section")
        ?.scrollIntoView({ behavior: "smooth" });
      break;
    }
    case "more-dev": {
      navigate("/skills#developer-section", { replace: true });
      break;
    }
    case "more-ig": {
      navigate("/skills#graphic-designer-section", { replace: true });
      break;
    }
  }
};

function onGoToUp() {
  document
    .getElementById("profile-section")
    ?.scrollIntoView({ behavior: "smooth" });
}
